
import { apiCall } from './apiCall';
  
  
  
export default function userApi() {
  return {
    getProfile: (data,token) => apiCall('/auth/user/profile/details',data, token,'GET'),
    update: (data,token) => apiCall('/updateUser',data, token),
    delete: (data,token) => apiCall('/deleteUser',data, token),
    changePassword: (data,token) => apiCall('/changePassword',data, token),
    getAgentList: (data,token) => apiCall('/getUsersList',data, token),
    create: (data,token) => apiCall('/addUser',data, token),
    getUserByID: (data,token) => apiCall('/getUserById',data, token),
    addCustomer: (data,token) => apiCall('/addUser',data, token),
    verify2FA: (data,token) => apiCall('/auth/verify2FAOtp',data, token),
    resend2FA: (data,token) => apiCall('/auth/send2FAOtpAgain',data, token),
    
  };
}
